/**
 * Displays a loading indicator in terminal-style format while fetching quotes
 * 
 * @returns A formatted loading message with terminal styling and blinking cursor
 */
function QuoteLoading() {
  return (
    <div className="flex items-center" data-testid="quote-loading">
      <span className="text-brand-text">$&nbsp;</span>
      <span className="ml-2">Loading inspiration...</span>
      <span className="w-2 h-5 bg-brand-amber animate-blink ml-1"></span>
    </div>
  );
}

export default QuoteLoading;
